const LocalStorage = {
  set: (key, jsonData, expirationMin) => {
    const expirationMS = expirationMin * 60 * 1000;
    const record = {
      value: JSON.stringify(jsonData),
      timestamp: new Date().getTime() + expirationMS
    };
    localStorage.setItem(key, JSON.stringify(record));

    return jsonData;
  },
  get: (key, expirationErr) => {
    const record = JSON.parse(localStorage.getItem(key));
    if (!record) {
      return expirationErr;
    }
    if (new Date().getTime() > record.timestamp) {
      localStorage.removeItem(key);

      return expirationErr;
    }

    return JSON.parse(record.value);
  },
  setRole: (role, expirationMin) => {
    if (role === 'NONE') {
      localStorage.removeItem('role');
    } else {
      LocalStorage.set('role', role, expirationMin);
    }

    return role;
  },
  getRole: () => LocalStorage.get('role', 'NONE'),

  setCampus: (campus, expirationMin) => {
    if (campus === 'NONE') {
      localStorage.removeItem('campus');
    } else {
      LocalStorage.set('campus', campus, expirationMin);
    }

    return campus;
  },
  getCampus: () => LocalStorage.get('campus', 'NONE'),

  setLogin: (role, expirationMin) => {
    if (role === 'NONE') {
      localStorage.removeItem('isLoggedIn');
    } else {
      LocalStorage.set('isLoggedIn', {}, expirationMin);
    }

    return role;
  },
  getLogin: () => LocalStorage.get('isLoggedIn'),

  setInstanceLinkUUID: (instanceLinkUUID, expirationMin) => {
    if (instanceLinkUUID === 'NONE') {
      localStorage.removeItem('instanceLinkUUID');
    } else {
      LocalStorage.set('instanceLinkUUID', instanceLinkUUID, expirationMin);
    }

    return instanceLinkUUID;
  },
  getInstanceLinkUUID: () => LocalStorage.get('instanceLinkUUID', 'NONE')
};

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/components/LocalStorage/index.jsx